export default __webpack_public_path__ + "7af2491362535e9b3249ffe7649d62cd.webp";